/**
 * Aparte indeling voor mobiel: de inhoud van blokken staat één keer in `blokken`;
 * `mobiel` bewaart alleen een eigen volgorde en welke blokken op mobiel verborgen zijn.
 *   mobiel = null                         → mobiel volgt desktop
 *   mobiel = { volgorde: [id], verborgen: [id] }
 */
export function sorteerVoorMobiel(blokken, mobiel) {
  if (!mobiel?.volgorde?.length) return blokken;
  const perId = new Map(blokken.map((b) => [b.id, b]));
  const eerst = mobiel.volgorde.map((id) => perId.get(id)).filter(Boolean);
  const gezien = new Set(eerst.map((b) => b.id));
  return [...eerst, ...blokken.filter((b) => !gezien.has(b.id))];
}

export function blokkenVoorWeergave(blokken, mobiel, isMobiel) {
  if (!isMobiel || !mobiel) return blokken;
  const verborgen = new Set(mobiel.verborgen || []);
  return sorteerVoorMobiel(blokken, mobiel).filter((b) => !verborgen.has(b.id));
}
